import React, { useState, useEffect } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";

import CmtCard from "@coremat/CmtCard";
import CmtCardContent from "@coremat/CmtCard/CmtCardContent";
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@material-ui/core";
import CmtSearch from "@coremat/CmtSearch";
import AdminlogTable from "./AdminLogTable";
import { useDispatch, useSelector } from "react-redux";
import UsersRequests from "services/users";

const useStyles = makeStyles((theme) => ({
  cardRoot: {
    [theme.breakpoints.down("xs")]: {
      "& .Cmt-header-root": {
        flexDirection: "column",
      },
      "& .Cmt-action-default-menu": {
        marginLeft: 0,
        marginTop: 10,
      },
    },
  },
  cardContentRoot: {
    padding: 0,
  },
  actionsContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "20px 20px",
  },
  buttonsContainer: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
  },
}));

const AdminLogContainer = () => {
  const classes = useStyles();
  const [searchVal, setSearchVal] = useState("");
  const [selectedAdminLogDB, setSelectedAdminLogDB] = useState("");
  const { adminLogDB } = useSelector(({ users }) => users);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(UsersRequests.getAdminLogsDB());
  }, []);

  useEffect(() => {
    if (adminLogDB && adminLogDB.length > 0) {
      setSelectedAdminLogDB(adminLogDB[0].faName);
    }
  }, [adminLogDB]);

  return (
    <CmtCard className={classes.cardRoot}>
      <CmtCardContent className={classes.cardContentRoot}>
        <Box className={classes.actionsContainer}>
          <Box className={classes.buttonsContainer}>
            <Box>
              <CmtSearch
                border={false}
                onlyIcon={false}
                iconPosition="left"
                align="left"
                placeholder="جست و جو"
                value={searchVal}
                onChange={(e) => setSearchVal(e.target.value)}
              />
            </Box>
          </Box>
          <FormControl variant="outlined" style={{ width: "250px" }}>
            <InputLabel id="demo-simple-select-outlined-label">
              پایگاه داده
            </InputLabel>
            <Select
              labelId="demo-simple-select-outlined-label"
              id="demo-simple-select-outlined"
              value={selectedAdminLogDB}
              onChange={(e) => setSelectedAdminLogDB(e.target.value)}
              label="selectedAdminLogDB"
            >
              {adminLogDB.map((item) => (
                <MenuItem value={item.faName}>{item.faName}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
        <AdminlogTable
          searchMode={searchVal.trim().length > 0}
          searchInput={searchVal}
          selectedAdminLogDB={
            adminLogDB[
              adminLogDB.findIndex((item) => item.faName === selectedAdminLogDB)
            ]?.name
          }
        />
      </CmtCardContent>
    </CmtCard>
  );
};

export default AdminLogContainer;
